import {redirect} from "react-router-dom";
import FertilityPerformances from "../../../services/UkTreatmentApi/FertilityPerformances";

export async function action({params}) {
    await FertilityPerformances.delete(params.fertilityPerformanceId);

    return redirect(`/farms/${params.farmUid}/fertility_performances`);
}